<script setup>
  import { ref, inject, onMounted, onBeforeUnmount } from 'vue'
  import Contact from '@/views/home/Contact.vue'

  const emitter = inject('emitter')

  const show = ref(false)

  const open = () => {
    show.value = true
  }

  const close = () => {
    show.value = false
  }

  const onKeydown = (e) => {
    if (e.key === 'Escape') {
      close()
    }
  }

  onMounted(() => {
    emitter.on('openContactModal', open)
    document.addEventListener('keydown', onKeydown)
  })

  onBeforeUnmount(() => {
    emitter.off('openContactModal', open)
    document.removeEventListener('keydown', onKeydown)
  })
</script>

<template>
  <transition name="contact-modal-fade">
    <div
      v-if="show"
      class="contact-modal-overlay"
      @click.self="close"
    >
      <div class="contact-modal">
        <button
          type="button"
          class="contact-modal__close"
          aria-label="Close"
          @click="close"
        >
          &times;
        </button>
        <div class="contact-modal__body">
          <Contact />
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
.contact-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 5vh 15px;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.75);
}

.contact-modal {
  position: relative;
  width: 100%;
  max-width: 900px;
  margin: auto;
  background: #1a1a24;
  border: 1px solid #312f3e;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);

  &__close {
    position: absolute;
    top: 12px;
    right: 16px;
    z-index: 2;
    width: 40px;
    height: 40px;
    padding: 0;
    line-height: 1;
    font-size: 28px;
    color: #b7b4c7;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: #f68b1f;
    }
  }

  &__body {
    padding: 10px 25px 30px;

    @media screen and (max-width: 768px) {
      padding: 10px 10px 20px;
    }

    // The Contact form is designed for a full page, tone it down for the modal
    .contact {
      padding-top: 2vh;
    }
  }
}

.contact-modal-fade-enter-active,
.contact-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.contact-modal-fade-enter-from,
.contact-modal-fade-leave-to {
  opacity: 0;
}
</style>
